import * as React from "react"
import { Badge, Box } from "@mui/material"


export default function stockStatusColumn() {
	return [{
		name: 'stock', label: 'Stock Status',
		options: {
			display: 'excluded',
			customBodyRowRender: value => value ? 'In stock' : 'Out of stock'
		}
	}, {
		name: 'stock', label: 'Stock Status',
		options: {
			filter: false,
			setCellHeaderProps: () => ({
				sx: { whiteSpace: 'normal', minWidth: 180 }
			}),
			customBodyRowRender: value => {
				return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
					<Badge color={value ? 'success' : 'error'} badgeContent=" "  sx={{ mb: 2 }}/>
				</Box>
			}
		}
	}]
}